export default __webpack_public_path__ + "static/media/img-guide-gt-popup-4-int_en@2x.7043ef0b.png";